module.exports = __webpack_public_path__ + "static/8th-f401404e2d630750245b80ba371ba8d2.png";